// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"vO-z","carouselContainer":"wO-z"};